// Module
var code = `<div class="jumbotron-surface file-media-surface">

  <div class="jumbotron-panel-head file-media-head">
    <div class="file-media-head-main" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed">
      <i class="fas fa-fw file-media-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading">File Media</span>
      <span class="jumbotron-note file-media-count">{{filteredFileMedia.length}} items</span>
    </div>

    <div class="file-media-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="ctrl.openResolutions()"
        title="Show the resolution of every asset">
        <i class="fas fa-table-list" aria-hidden="true"></i> Resolutions
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary"
        ng-click="ctrl.showFilters = !ctrl.showFilters" title="Show or hide the filters">
        <i class="fas fa-filter" aria-hidden="true"></i>
        <span ng-if="!ctrl.showFilters">Filters</span>
        <span ng-if="ctrl.showFilters">Hide</span>
      </button>
    </div>
  </div>

  <div class="file-media-body" ng-show="!ctrl.isCollapsed">

    <div class="file-media-filters" ng-show="ctrl.showFilters">
      <div class="row g-3 align-items-end">
        <div class="col-md-6 col-lg-3">
          <label class="jumbotron-field-label form-label file-media-field-label" for="fileMediaSort">Sort by</label>
          <select id="fileMediaSort" class="form-select form-select-sm" ng-model="ctrl.sortOption">
            <option value="name">Name</option>
            <option value="createdAtDesc">Created (Newest First)</option>
            <option value="createdAt">Created (Oldest First)</option>
            <option value="duration">Duration</option>
            <option value="mediaInUse">Usage Count</option>
          </select>
        </div>
        <!-- The usage of a media is a count inside the open playlist, so this
             filter is only on the page while a playlist is open. -->
        <div class="col-md-6 col-lg-2" ng-if="ctrl.isSceneActive()">
          <label class="jumbotron-field-label form-label file-media-field-label" for="fileMediaUsage">Usage</label>
          <select id="fileMediaUsage" class="form-select form-select-sm" ng-model="ctrl.selectedMediaUsage">
            <option value="all">All</option>
            <option value="inUse">In Use</option>
            <option value="notInUse">Not In Use</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-2">
          <label class="jumbotron-field-label form-label file-media-field-label" for="fileMediaDate">Date</label>
          <select id="fileMediaDate" class="form-select form-select-sm" ng-model="ctrl.selectedDate">
            <option value="">All</option>
            <option ng-repeat="date in ctrl.getUniqueDates()" value="{{date}}">{{date | date:'dd/MM yy EEE'}}</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-3">
          <label class="jumbotron-field-label form-label file-media-field-label" for="fileMediaLabel">Label</label>
          <select id="fileMediaLabel" class="form-select form-select-sm" ng-model="ctrl.selectedLabel">
            <option value="">All</option>
            <option ng-repeat="label in ctrl.labelsInUse" ng-value="label">{{label.name}}</option>
          </select>
        </div>
        <div class="col-lg-2 col-md-12">
          <button type="button" class="btn btn-sm btn-outline-secondary w-100" ng-click="ctrl.clearFilters()">
            <i class="fas fa-times" aria-hidden="true"></i> Clear Filters
          </button>
        </div>
      </div>

      <!-- The sort by usage needs an open playlist. The box tells the operator why
           the column is empty. -->
      <div class="jumbotron-note-box is-warn" ng-if="ctrl.sortOption === 'mediaInUse' && !ctrl.isSceneActive()">
        <i class="fas fa-info-circle" aria-hidden="true"></i>
        Usage Count requires an open playlist. Please select a playlist in edit mode.
      </div>
    </div>

    <div class="file-media-scrollable">
      <div class="jumbotron-media-grid">
        <asset-upload-drop-zone class="file-media-drop-zone"
          on-ready="ctrl.dropZone = \$dropZone"></asset-upload-drop-zone>
        <div class="jumbotron-media-tile"
          ng-repeat="item in filteredFileMedia = (ctrl.FileMedia | filter:ctrl.filterByMediaUsage | orderBy:ctrl.getSortKey(ctrl.sortOption) | filter:ctrl.filterByDate(ctrl.selectedDate) | filter:ctrl.filterByLabel)">
          <bulk-select class="jumbotron-media-tile-header" title="{{item.name}}" media-title="item.name"
            on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
          <div class="jumbotron-media-tile-content">
            <div ng-repeat="asset in item.assets"
              ng-if="\$first && asset.type === 'video' && asset.height === 2160" class="video4k-label">4K</div>
            <img class="jumbotron-media-tile-thumb" alt="Thumbnail" draggable="false" ng-src="{{ctrl.getThumbnailUrl(item.id)}}"
              ng-click="ctrl.openPreview(item)" />
            <div class="jumbotron-media-tile-controls">
              <div class="jumbotron-media-tile-control">
                <div class="d-grid">
                  <button type="button" class="btn btn-sm btn-outline-primary"
                    ng-if="ctrl.scene && (ctrl.getOrientations(item.id) === 'both' || ctrl.getOrientations(item.id) === ctrl.scene.orientation)"
                    ng-click="ctrl.addToScene(item.id)"
                    ng-disabled="!ctrl.isSceneActive() || ctrl.getEvent(item.id) || !ctrl.getType(item.id)">
                    <i class="fas fa-plus-circle" aria-hidden="true"></i> Add to playlist
                    <span ng-if="ctrl.mediaInUse[item.id]">({{ ctrl.mediaInUse[item.id] }})</span>
                  </button>
                </div>
              </div>
              <div class="jumbotron-media-tile-control file-media-meta d-flex justify-content-between align-items-center">
                <div>
                  <i class="fas fa-fw" aria-hidden="true" ng-class="ctrl.getIcon(item.id)"></i>
                  <i class="fas fa-fw" aria-hidden="true"
                    ng-class="{'fa-arrows-up-down-left-right': ctrl.getOrientations(item.id) === 'both', 'fa-arrows-left-right': ctrl.getOrientations(item.id) === 'l', 'fa-arrows-up-down': ctrl.getOrientations(item.id) === 'p'}"></i>
                  <i ng-if="ctrl.getDuration(item.id)" class="fa fa-fw fa-clock" aria-hidden="true"></i>
                  {{ctrl.getDuration(item.id) | duration}} <i class="fa fa-upload" aria-hidden="true"></i>
                  <span title="Upload date"> {{item.createdAt | amDateFormat:'DD/MM YY'}}</span>
                </div>
                <button type="button" class="btn btn-sm btn-discreet-danger" ng-click="ctrl.delete(item.id)"
                  ng-disabled="item.sceneCollections" aria-label="Delete {{item.name}}" title="Delete this media">
                  <i class="fas fa-trash" aria-hidden="true"></i>
                </button>
              </div>
              <div class="jumbotron-media-tile-control text-end">
                <span ng-show="ctrl.getEvent(item.id) === 'analyze'">
                  <span>Analyzing</span>
                  <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                </span>
              </div>
              <div class="jumbotron-media-tile-control">
                <media-labels filemedia-id="item.id"></media-labels>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The three dialogs are outside the body of the panel. A dialog under a
       hidden element is in the top layer without being drawn, and the body is
       hidden while the panel is collapsed. All three are the shared dialog
       element, so the browser owns the top layer, the dimmed page and the
       Escape key.

       The question about a file that already exists belongs to the drop zone in
       the grid. The drop zone hands this panel its controller, so the question
       stands here and the answers go back to the upload. -->
  <asset-upload-conflict-modal ng-if="ctrl.dropZone" conflicts="ctrl.dropZone.conflicts"
    show-conflict-modal="ctrl.dropZone.showConflictModal"
    confirm-replace="ctrl.dropZone.confirmReplace()" cancel-upload="ctrl.dropZone.cancelUpload()"
    get-orientation-text="ctrl.dropZone.getOrientationText(orientation)">
  </asset-upload-conflict-modal>

  <dialog class="jumbotron-dialog" jumbotron-dialog="ctrl.previewOpen"
    aria-labelledby="file-media-preview-heading">
    <div class="jumbotron-panel-head">
      <h2 class="jumbotron-heading" id="file-media-preview-heading">Media Preview</h2>
      <button type="button" class="btn-close" ng-click="ctrl.closePreview()" aria-label="Close"></button>
    </div>
    <div class="jumbotron-dialog-body" ng-if="ctrl.previewOpen">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-{{12 / ctrl.currentItem.assets.length}}"
            ng-repeat="asset in ctrl.currentItem.assets">
            <div class="file-media-preview-frame-box">
              <div class="file-media-preview-frame" ng-if="asset.type === 'video' || asset.type === 'image'"
                ng-class="{ 'is-pillarbox': overlay.mode === 'pillarbox' }"
                ng-style="overlay.frameStyle"
                ng-init="overlay = ctrl.getPreviewSafeAreaOverlay(asset)">
                <video ng-if="asset.type === 'video'" controls autoplay muted disableremoteplayback>
                  <source ng-src="{{ctrl.S3url}}/{{ asset.fileKey }}" type="video/mp4">
                </video>
                <img ng-if="asset.type === 'image'" ng-src="{{ctrl.S3url}}/{{ asset.fileKey }}"
                  alt="{{ ctrl.currentItem.name }}" />
                <div ng-if="overlay" class="preview-safe-area">
                  <div ng-if="overlay.mode === 'pillarbox'" class="preview-safe-area__bar"
                    ng-style="overlay.leftBarStyle"></div>
                  <div ng-if="overlay.mode === 'pillarbox'" class="preview-safe-area__bar"
                    ng-style="overlay.rightBarStyle"></div>
                  <div class="preview-safe-area__box" ng-style="overlay.boxStyle"></div>
                  <div class="preview-safe-area__label"
                    title="{{ctrl.getPreviewSafeAreaTooltip(overlay)}}">
                    {{ctrl.getPreviewSafeAreaLabel(overlay)}}</div>
                </div>
              </div>
            </div>
            <table class="jumbotron-table file-media-asset-table">
              <tbody>
                <tr ng-repeat="(key, value) in asset" ng-if="key !== 'hash'">
                  <th class="jumbotron-table-head-cell" scope="row">{{ key }}</th>
                  <td class="jumbotron-table-cell">{{ key === 'bytes' ? (value / 1048576 | number:1) + ' MB' : value }}</td>
                </tr>
                <tr ng-if="asset.width && asset.height">
                  <th class="jumbotron-table-head-cell" scope="row">aspect</th>
                  <td class="jumbotron-table-cell">{{ (asset.width / asset.height).toFixed(2) }}:1</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="jumbotron-dialog-foot">
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="ctrl.closePreview()">Close</button>
    </div>
  </dialog>

  <dialog class="jumbotron-dialog file-media-resolutions-dialog" jumbotron-dialog="ctrl.resolutionOpen"
    aria-labelledby="file-media-resolutions-heading">
    <div class="jumbotron-panel-head">
      <h2 class="jumbotron-heading" id="file-media-resolutions-heading">
        <i class="fas fa-table-list" aria-hidden="true"></i> Media Resolutions
      </h2>
      <button type="button" class="btn-close" ng-click="ctrl.closeResolutions()" aria-label="Close"></button>
    </div>
    <div class="jumbotron-dialog-body p-0">
      <table class="jumbotron-table file-media-resolutions-table">
        <thead>
          <tr>
            <th class="jumbotron-table-head-cell file-media-sort-cell" ng-click="ctrl.sortResolutionBy('name')">
              Name <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'name' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
            <th class="jumbotron-table-head-cell file-media-sort-cell" ng-click="ctrl.sortResolutionBy('type')">
              Type <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'type' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
            <th class="jumbotron-table-head-cell file-media-sort-cell" ng-click="ctrl.sortResolutionBy('orientation')">
              Orientation <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'orientation' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
            <th class="jumbotron-table-head-cell jumbotron-number-cell file-media-sort-cell file-media-num" ng-click="ctrl.sortResolutionBy('width')">
              Resolution <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'width' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
            <th class="jumbotron-table-head-cell jumbotron-number-cell file-media-sort-cell file-media-num" ng-click="ctrl.sortResolutionBy('aspect')">
              Aspect <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'aspect' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
            <th class="jumbotron-table-head-cell jumbotron-number-cell file-media-sort-cell file-media-num" ng-click="ctrl.sortResolutionBy('bitrate')">
              Bitrate <i class="fas fa-xs ms-1" aria-hidden="true"
                ng-class="ctrl.resolutionSort.key === 'bitrate' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in ctrl.resolutionRows | orderBy:ctrl.resolutionSort.key:ctrl.resolutionSort.reverse">
            <td class="jumbotron-table-cell">{{ row.name }}</td>
            <td class="jumbotron-table-cell"><i class="fas fa-fw" aria-hidden="true" ng-class="row.type === 'video' ? 'fa-film' : 'fa-image'"></i></td>
            <td class="jumbotron-table-cell"><i class="fas fa-fw" aria-hidden="true"
                ng-class="{'fa-arrows-up-down-left-right': row.orientation === 'both', 'fa-arrows-left-right': row.orientation === 'l', 'fa-arrows-up-down': row.orientation === 'p'}"></i></td>
            <td class="jumbotron-table-cell jumbotron-number-cell file-media-num">{{ row.width }} × {{ row.height }}</td>
            <td class="jumbotron-table-cell jumbotron-number-cell file-media-num">{{ row.aspect | number:2 }}:1</td>
            <td class="jumbotron-table-cell jumbotron-number-cell file-media-num"><span ng-if="row.bitrate">{{ row.bitrate | number:1 }} Mbps</span><span class="file-media-muted" ng-if="!row.bitrate">&ndash;</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="jumbotron-dialog-foot">
      <small class="jumbotron-note file-media-count me-auto">{{ ctrl.resolutionRows.length }} assets</small>
      <button type="button" class="btn btn-sm btn-outline-secondary"
        ng-click="ctrl.closeResolutions()">Close</button>
    </div>
  </dialog>
</div>
`;
// Exports
export default code;